import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { defaultThemeStyles as defaultThemeAppStyles } from 'blocks.app/app/app.theme.jcss'
import { defaultThemeStyles as defaultThemeSidebarStyles } from 'blocks.app/sidebar/Sidebar-theme'
import { colors, indents, IStyles } from 'theme'

const editorAreaSettings: IStyles = {
    inputWrapper: {
        ...grid.w45,
    },
    inputWrapperFull: {
        ...grid.w100,
    },
    row: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        ...grid.p_md,
        ...grid.pb_none,
    },
    buttons: {
        ...grid.row,
        ...grid.center,
    },
    heightAndWidthRow: {
        ...grid.row,
        ...grid.justify,
        ...grid.p_md,
        ...grid.pb_none,
    },
    title: {
        ...grid.p_md,
        ...grid.mb_mdPlus,
        textAlign: 'center',
        color: `var(--var-module-sidebar-component-sidebar-style-title, ${defaultThemeSidebarStyles.title})`,
    },
    collapse: {
        borderRadius: `0!important`,
    },
    collapseText: {
        ...grid.p_md,
        textAlign: 'center',
        color: `var(--var-module-sidebar-component-sidebar-style-title, ${defaultThemeSidebarStyles.title})`,
    },
    collapseTitle: {
        padding: '0!important',
        ...grid.centerImportant,
        borderBottom: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeAppStyles.border})`,
    },
    collapseActive: {
        borderBottom: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeAppStyles.border})`,
    },
    borderTop: {
        borderTop: `1px solid var(--var-module-app-component-app-style-border, ${defaultThemeAppStyles.border})`,
    },
    checkBox: {
        ...grid.pl_md,
        ...grid.pt_md,
    },
    label: {
        textAlign: 'center',
        marginBottom: indents.mini,
    },
    autoPosSelected: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        margin: '24px 0 0 0',
    },
    autoPosSelectedTitle: {
        marginBottom: 10,
    },
    adIdsWrapper: {
        position: 'relative',
    },
    adIdsHelper: {
        position: 'absolute',
        top: '93%',
        left: 21,
        right: 21,
        padding: '5px 10px 0 10px',
        border: '1px solid var(--var-module-ui-component-editText-style-withLightBorder-border, #494848)',
        borderRadius: 5,
        borderTop: 'none',
        background: colors.white,
        zIndex: 1,
        maxHeight: 200,
        overflow: 'auto',
    },
    adListItem: {
        margin: '10px 0',
        cursor: 'pointer',
    },
    adNoIds: {
        cursor: 'auto',

        span: {
            textDecoration: 'underline',
            cursor: 'pointer',

            '&:hover': {
                textDecoration: 'none',
            },
        },
    },
}

addStyles(editorAreaSettings)
export default editorAreaSettings
